
<template>
  <div class="container-fluid mt-4">

    <h1 v-if="title" class="h1 mt-5 mb-4">{{ title_text ? title_text : tableName + 's' | capitalize }}</h1>
    <b-row v-if="tableLink">
      <b-col>
        <div class="col text-right">
            <button class="btn btn-dark btn-rounded" data-toggle="modal" data-target="#newDevice">
              <router-link
                :to="`${tableLink.to}`"
                :id="tableLink.id"
              > {{tableLink.text}}
              </router-link>
            </button>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-table
          :id="`${tableName}-table`"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :striped="!stacked"
          show-empty
          :busy="loading"
          :stacked="stacked"
        >

          <template slot="table-busy">
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong style="margin-left:20px">Loading...</strong>
            </div>
          </template>

          <template v-slot:[`cell(${id.name})`]="item" v-for="(id, i) in ids">
            <router-link
              :to="`/${id.to}/${item.item[id.id]}`"
              :id="`${id.to}-${tableName}-${item.item[id.id]}`"
              :key="i"
            >
              {{ item.item[id.name] }}
            </router-link>
          </template>

          <template v-slot:cell(action)="item">
              <div style="float:right; width:80px">
                  <b-link @click="edit_item(item.item.id)">
                      <span style="float: left;" class="icon-blue mx-1"><img src="/icons/icon-edit.png" height="15"></span>
                  </b-link>
                  <b-link @click="confirm_delete(item.item.id)">
                      <span style="float: right;" class="icon-blue mx-1"><img src="/icons/icon-delete.png" height="15"></span>
                  </b-link>
              </div>
          </template>

        </b-table>

        <b-row v-if="pagination">
          <b-col>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
            >
            </b-pagination>
          </b-col>
        </b-row>

      </b-col>
    </b-row>
  </div>
</template>

<script>

    import TableAction from './TableAction'

    const confirmation_box_config = {
        title: 'Confirm deletion',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
    }

    export default {
        name: 'k-table',

        components: { TableAction },

        props:{
            fields: {type: Array, default:[]},
            items:{ type: Array, default: [] },
            ids: {type: Array, default: []},
            tableLink: {type: Object, required: false },
            tableName: {type: String, required: false },
            title: {type: Boolean, required: false },
            title_text: { type: String, required: false },
            loading: {type: Boolean, required: true },
            stacked: {type: Boolean, required: true },
            title: {type: Boolean, required: false },
            pagination: { type: Boolean, default: true}
        },

        data(){
            return {
                currentPage: 1,
                perPage: 20,
                totalRows: 0,
            }
        },

        methods:{

            async confirm_delete(id){
                const value = await this.$bvModal.msgBoxConfirm(
                    `Are you sure you want to delete this ${this.tableName}?`,
                    confirmation_box_config
                )
                value ? this.delete_item(id) : null
            },
            async edit_item(id){
                this.$emit('edit_item', id)
            },
            async delete_item(id){
                this.$emit('delete_item', id)
            },
            actionTo: function(item) {
                return `${this.tableName.toLowerCase()}s/${item.id}`
            }

        },

        filters: {
            capitalize: value => value ? String(value).charAt(0).toUpperCase() + String(value).slice(1) : ''
        },

        watch:{
            items(items){ this.totalRows = items.length }
        }
    }

</script>

<style>

    .btn-rounded {
        border-radius: 40px !important;
    }
    .btn-green{
        background-color: #00a716;
        color: #fff !important;
    }
    
    .btn-green:hover {
        background-color: #249452;
        color: #fff !important;
    }

</style>